import { Component, Input } from '@angular/core';
import { FilterType, SortIconComponent, SortIconType } from '../sort-icon/sort-icon.component';

@Component({
  selector: 'app-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss'],
  imports: [SortIconComponent],
})
export class TableHeaderComponent {
  @Input() label = '';
  @Input() field = '';
  @Input() type: SortIconType = 'string';
  @Input() filter?: FilterType;
  @Input() filterName?: string;
}
